import { render, staticRenderFns } from "./markdown-input.vue?vue&type=template&id=387c3188"
import script from "./markdown-input.vue?vue&type=script&lang=js"
export * from "./markdown-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports